import * as yup from 'yup';

import { emailYupValidation } from '@/shared/utils/validationSchema';

export const usuarioSistemaFormSchema = yup.object({
  tipo_identificacion: yup
    .string()
    .required('El campo tipo_identificacion es requerido'),
  identificacion: yup.string().required('El campo identificacion es requerido'),
  razon_social: yup.string().required('El campo razon_social es requerido'),

  username: yup.string().required('El campo username es requerido'),
  email: emailYupValidation,
  isEdit: yup.boolean().optional(),
  password: yup
    .string()
    .when('isEdit', {
      is: false,
      then: schema =>
        schema
          .required('El campo password es requerido')
          .min(5, 'La contraseña debe tener al menos 5 caracteres')
          .max(33, 'La contraseña debe tener como máximo 33 caracteres'),
    })
    .max(50, 'El campo password no puede tener más de 50 caracteres'),
  empresa: yup.string().required('El campo empresa es requerido'),
  area: yup.string().required('El campo area es requerido'),
  departamento: yup.string().required('El campo departamento es requerido'),
  rol: yup.string().required('El campo rol es requerido'),

  grupos: yup.array().of(yup.number()).optional(),

  canal_venta: yup.string().optional().nullable(),

  // create_employee
  create_employee: yup.boolean().optional(),
  direccion: yup
    .string()
    .optional()
    .nullable()
    .when('create_employee', {
      is: true,
      then: schema =>
        schema
          .required('El campo direccion es requerido')
          .max(250, 'El campo direccion no debe exceder los 250 caracteres'),
    }),
  telefono_1: yup
    .string()
    .optional()
    .nullable()
    .when('create_employee', {
      is: true,
      then: schema => schema.required('El campo telefono 1 es requerido'),
    }),
  telefono_2: yup
    .string()
    .optional()
    .nullable()
    .when('create_employee', {
      is: true,
      then: schema => schema.required('El campo telefono 2 es requerido'),
    }),
  telefono_3: yup
    .string()
    .optional()
    .nullable()
    .when('create_employee', {
      is: true,
      then: schema => schema.required('El campo telefono 3 es requerido'),
    }),
  cargo: yup
    .string()
    .optional()
    .nullable()
    .when('create_employee', {
      is: true,
      then: schema => schema.required('El campo cargo es requerido'),
    }),
  tipo_empleado: yup
    .string()
    .optional()
    .nullable()
    .when('create_employee', {
      is: true,
      then: schema => schema.required('El campo tipo empleado es requerido'),
    }),
  pais: yup
    .string()
    .optional()
    .nullable()
    .when('create_employee', {
      is: true,
      then: schema => schema.required('El campo pais es requerido'),
    }),
  provincia: yup
    .string()
    .optional()
    .nullable()
    .when('create_employee', {
      is: true,
      then: schema => schema.required('El campo provincia es requerido'),
    }),
  ciudad: yup
    .string()
    .optional()
    .nullable()
    .when('create_employee', {
      is: true,
      then: schema => schema.required('El campo ciudad es requerido'),
    }),
  zona: yup
    .string()
    .optional()
    .nullable()
    .when('create_employee', {
      is: true,
      then: schema => schema.required('El campo zona es requerido'),
    }),
  sector: yup
    .string()
    .optional()
    .nullable()
    .when('create_employee', {
      is: true,
      then: schema => schema.required('El campo sector es requerido'),
    }),
});
